import IFrameContainer from './IFrameContainer'

export default IFrameContainer
